import { useTranslations } from "next-intl";
import { useButtonEventTracking } from "@hooks/use-button-event-tracking";
import ProductImagesTrio from "@components/core/ProductImagesTrio";

function UserListHorizontalCard({ userList, onClick, trackingName }) {
  const t = useTranslations("common");

  const trackEvent = useButtonEventTracking();

  function handleClick() {
    trackEvent(trackingName);

    onClick();
  }

  return (
    <button
      className="btn-transparent w-100"
      onClick={handleClick}
    >
      <div className="userlist-horizontal-card with-hover-effect">
        <div className="userlist-horizontal-card-content">
          <div className="userlist-horizontal-card-infos">
            <p
              className="mb-0 font-weight-bold text-1-line"
              style={{ height: "24px" }}
            >
              {userList.name}
            </p>
            <p className="mb-0 font-size-sm">
              {t("userlist.items", {
                count: userList.products_count || 0,
              })}
            </p>
          </div>
          <div className="userlist-horizontal-card-images-container">
            <ProductImagesTrio
              images={userList.first_products_pictures}
              className="userlist-horizontal-card-images-container"
            />
          </div>
        </div>
      </div>
    </button>
  );
}

export default UserListHorizontalCard;
